import {FaTable} from "react-icons/fa6";
import {FiFilter} from "react-icons/fi";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {formatDate} from "@/components/dateUtils.tsx";
import {SLAReportDropdownButtonAction} from "@/pages/reports/sla/details/actions/SLAReportDropdownButtonAction.tsx";
import {DropdownButtonActionItem} from "@/pages/reports/sla/details/actions/SLAReportDropdownButtonActions.ts";

export interface SLAReportDownloadDropdownProps {
  id: number;
  start: Date;
  end: Date;
  query: string;
  hasGroups: boolean;
}

export const SLAReportDownloadDropdown = ({id, start, end, query, hasGroups}: SLAReportDownloadDropdownProps) => {
  const {brand} = useCurrentUserContext();
  let dropdownItems: DropdownButtonActionItem[] = [
    {
      text: "Download PDF",
      href: `${brand.siteURL}/reports/sla/${id}/pdf?start=${formatDate(start)}&end=${formatDate(end)}&search=${query}`,
      target: "_blank",
    },
    {
      text: "Download XLS",
      href: `${brand.siteURL}/reports/sla/${id}/xls?start=${formatDate(start)}&end=${formatDate(end)}&search=${query}`,
      target: "_blank",
    },
  ];

  if (hasGroups) {
    dropdownItems.unshift({
      title: "Filtered Data",
      icon: FiFilter,
    });
    dropdownItems = dropdownItems.concat([
      {
        text: "Download PDF (no children)",
        href: `${brand.siteURL}/reports/sla/${id}/pdf?start=${start}&end=${end}&search=${query}&group_only=true`,
        target: "_blank",
      },
      {
        text: "Download XLS (no children)",
        href: `${brand.siteURL}/reports/sla/${id}/xls?start=${start}&end=${end}&search=${query}&group_only=true`,
        target: "_blank",
      },
      {
        divider: true,
      },
      {
        title: "All Data",
        icon: FaTable,
      },
      {
        text: "Download PDF (no children)",
        href: `${brand.siteURL}/reports/sla/${id}/pdf`,
        target: "_blank",
      },
      {
        text: "Download XLS (no children)",
        href: `${brand.siteURL}/reports/sla/${id}/xls`,
        target: "_blank",
      },
    ]);
  }

  return <SLAReportDropdownButtonAction items={dropdownItems} />;
};
